import React from "react";
import { Link } from "react-router-dom";
import { NAV_ORDER, TYPES } from "@/config";

export function Footer() {
  return (
    <footer data-testid="site-footer" className="mt-32 border-t border-line bg-surface">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10 py-16">
        <div className="grid gap-12 md:grid-cols-[1.5fr_1fr_1fr]">
          <div>
            <div className="flex items-baseline gap-3">
              <span className="font-serif text-4xl text-gold">COA</span>
              <span className="eyebrow text-faint">Crimes of Art</span>
            </div>
            <p className="mt-5 max-w-md font-serif text-xl leading-relaxed text-faint">
              A living library and publication documenting art crime, law, and controversy — the
              thefts, forgeries, artists, institutions, and legal battles that have shaped the
              history of art, from antiquity to the present.
            </p>
          </div>

          <div>
            <div className="eyebrow mb-4">The Archive</div>
            <ul className="space-y-3">
              {NAV_ORDER.map((k) => (
                <li key={k}>
                  <Link to={`/${TYPES[k].segment}`} className="text-sm text-parchment/70 hover:text-gold link-underline">
                    {TYPES[k].label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="eyebrow mb-4">The Publication</div>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-sm text-parchment/70 hover:text-gold link-underline">About COA</Link></li>
              <li><Link to="/search" className="text-sm text-parchment/70 hover:text-gold link-underline">Search</Link></li>
              <li><a href="mailto:crimesofart@gmail.com" data-testid="footer-contact-link" className="text-sm text-parchment/70 hover:text-gold link-underline">Contact</a></li>
              <li><Link to="/login" data-testid="footer-admin-link" className="text-sm text-parchment/70 hover:text-gold link-underline">Editorial Access</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-3 border-t border-line pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-faint">© {new Date().getFullYear()} COA · Crimes of Art.</p>
          <p className="font-mono text-xs text-faint">Theft · forgery · restitution · censorship · authentication · law</p>
        </div>
      </div>
    </footer>
  );
}
